/**
 * Stable block IDs for HTML/markdown blocks.
 *
 * Each block (heading, paragraph, list_item, code_block, blockquote, table)
 * gets an `id` attribute derived from sha256(type + ":" + normalize(text)).
 * Stability:
 *   - Same content → same id (idempotent on re-parse).
 *   - Edited content → different id (new annotation target needs fuzzy match).
 */

async function sha256Hex16(s: string): Promise<string> {
  const data = new TextEncoder().encode(s);
  const buf = await crypto.subtle.digest("SHA-256", data);
  const bytes = new Uint8Array(buf);
  let hex = "";
  for (let i = 0; i < 8; i += 1) {
    hex += (bytes[i] ?? 0).toString(16).padStart(2, "0");
  }
  return hex;
}

function normalize(text: string): string {
  return text
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase()
    .normalize("NFKD")
    .replace(/\p{M}+/gu, "");
}

export async function computeBlockId(type: string, text: string): Promise<string> {
  return sha256Hex16(`${type}:${normalize(text)}`);
}
